export const getBackgroundImageFromUrl = (
  url: string,
  xPos: string = 'center',
  yPos: string = 'center',
  size: string = 'contain'
) => `url(${url}) ${xPos} ${yPos} / ${size} no-repeat`;
